module.exports = __webpack_public_path__ + "img/two.3dd69e03.svg";